import React from 'react';

const Imprint = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <section className="bg-black text-white py-20">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Impressum
          </h1>
          <p className="text-xl text-white/80 max-w-2xl">
            Angaben gemäß § 5 TMG
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Anbieter */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Anbieter</h2>
            <div className="text-gray-700 space-y-1">
              <p className="font-semibold">Positiv Fitness Wolnzach GmbH</p>
              <p>Preysingstraße 64</p>
              <p>85283 Wolnzach</p>
              <p>Deutschland</p>
              <p className="mt-4">Telefon: 08442/677300</p>
              <p>E-Mail: wolnzach@positiv-gruppe.de</p>
            </div>
          </div>

          {/* Vertretungsberechtigte Person */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Vertretungsberechtigte Person</h2>
            <p className="text-gray-700">
              Roman Schenkl, Geschäftsführer
            </p>
          </div>

          {/* Registereintrag */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Registereintrag</h2>
            <div className="text-gray-700 space-y-1">
              <p>Handelsregister: Amtsgericht Ingolstadt</p>
              <p>Registernummer: HRB 5427</p>
            </div>
          </div>

          {/* Umsatzsteuer */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Umsatzsteuer</h2>
            <div className="text-gray-700 space-y-1">
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE269219376</p>
              <p>Steuernummer: 124/135/30537</p>
            </div>
          </div>

          {/* Verantwortlich für Inhalte */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Verantwortlich für journalistisch-redaktionelle Inhalte (§ 18 Abs. 2 MStV)</h2>
            <div className="text-gray-700 space-y-1">
              <p className="font-semibold">Roman Schenkl</p>
              <p>Preysingstraße 64</p>
              <p>85283 Wolnzach</p>
            </div>
          </div>

          {/* Streitschlichtung */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Streitschlichtung</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: {' '}
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black underline hover:no-underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          {/* Stand */}
          <div className="border-t pt-8 mt-12">
            <p className="text-gray-500 text-sm">
              Stand: Februar 2026
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Imprint;
